// extracted by mini-css-extract-plugin
export var avatarContainer = "_dy-0";
export var avatarTypingWave = "_dy-i";
export var gray = "_dy-f";
export var green = "_dy-c";
export var icon = "_dy-9";
export var image = "_dy-1";
export var lg = "_dy-6";
export var md = "_dy-5";
export var presenceDot = "_dy-b";
export var red = "_dy-d";
export var sm = "_dy-4";
export var status = "_dy-a";
export var typingDot = "_dy-h";
export var typingPill = "_dy-g";
export var xl = "_dy-7";
export var xs = "_dy-3";
export var xxl = "_dy-8";
export var xxs = "_dy-2";
export var yellow = "_dy-e";